import {getDocumentName, UiDms} from "./UiDms";
import {BaseEditor, formGroup} from "../BaseEditor";
import {UiTomSelect} from "../components/UiTomSelect";
import {MuWidget} from "mu-widget/lib/MuWidget";
import {DmsDocument, DmsDocumentType, DmsDocumentTypeOpts} from "./Types";
import {UiFlashMessage} from "../UiFlashMessage";
import {TreeSelector} from "../TreeSelector";
import {RadioListItem, UiRadioList} from "../components/UiRadioList";
import {SlashTree} from "../SlashTree";
import {UiTree} from "../components/UiTree";
import {UiOrgProjectsActionCell} from "./UiDmsOrgProjects";

export class UiDmsDocumentEditor extends BaseEditor
{
	private parentDocument: DmsDocument;
	private stateOpts: any;

	beforeIndex() {
		super.beforeIndex();
		this.muAppendContent(`
			<div mu-id="selectType">
				<fieldset><legend>Vyberte typ dokumentu</legend>
					<!-- <ul mu-id="documentTypes" mu-bind="documentTypes:@foreach">
						<li mu-template="documentTypeItem" mu-widget="UiDmsDocumentEditorType" mu-bind="id:.id">
							<span class="btn btn-link" mu-id="bSelectType" mu-bind="name"></span>
						</li>
					</ul> -->
					<ul mu-id='newTypesTree' mu-widget="UiTree">
						<li mu-template="item" mu-widget=".">
							<span mu-bind='pathItemName;id|tern("a icon-before-document-file","strong"):className;id:dmsDocumentTypeId' class="strong cursor-pointer icon-before-document-dir" mu-id="bSelectType"></span>
							<ul mu-id="items" style="display: none"></ul>
						</li>
					</ul>
				</fieldset>
			</div>
			<div mu-id="editor">
				<fieldset><legend>Základní údaje</legend>
					<div class="form-group clearfix" mu-id="block_dmsDocumentTypeName">
						<label mu-for="" class="col-sm-3 control-label">Typ</label>
						<div class="col-sm-9">
							<span mu-bind="dmsDocumentTypeName"></span>							
							<span mu-id="parentDmsDocument" class="a"></span>
						</div>
					</div>

					<div class="form-group clearfix" mu-id="block_stateId">
						<label mu-for="stateId" class="col-sm-3 control-label">Stav</label>
						<div class="col-sm-9">
							<div class="checkbox" mu-widget="UiRadioList" mu-id="stateId" mu-bind="stateId"></div>
						</div>
					</div>
				`
				+ formGroup('cancelNote', 'Poznámka ke stornu',
				`<textarea mu-id="cancelNote" mu-bind="cancelNote" class="form-control" rows="5"></textarea>`
				)
				+ `					
					<div class="form-group clearfix" mu-id="securityLevel_stateId">
						<label mu-for="securityLevel" class="col-sm-3 control-label">Stupeň utajení dokumentu</label>
						<div class="col-sm-9">
							<div class="checkbox" mu-widget="UiRadioList" mu-id="securityLevel" mu-bind="securityLevel"></div>
						</div>
					</div>`

				+ formGroup('dmsDocumentClassId', 'Druh',
					`<div mu-widget="UiTomSelect" mu-id="dmsDocumentClassId" mu-bind="dmsDocumentClassId"></div>`
				)

				+ formGroup('name', 'Název',
					`<input type="text" class="form-control" mu-id="name" mu-bind="name" />`
				)

				+ formGroup('orgProjectId', 'Projekt',
					`<div mu-widget="UiOrgProjectSelector" mu-id="orgProjectId" mu-bind="orgProjectId"></div>
					<div mu-for="error:orgProjectId"></div>
					<span class="btn btn-link" mu-id="bSetProjectResponsible">Nastavit odpovědnou osobu.</span>
					<span class="btn btn-link" mu-id="bSetProjectOrgDivision">Nastavit středisko.</span>`
				)

				+ formGroup('responsibleId', 'Odpovědná osoba',
					`<div mu-widget="UiAccountSelector" mu-id="responsibleId" mu-bind="responsibleId"></div>`
				)

				+ formGroup('orgDivisionId', 'Středisko',
					`<div mu-widget="TreeSelector" mu-id="orgDivisionId" mu-params='{"inModal":true}' mu-bind="orgDivisionId"></div>`
				)

				+ formGroup('amount', 'Částka / měna',
					`<div class="input-group display-flex">
						<input type="number" mu-id="amount" mu-bind="amount" class="form-control flex-grow-1"  />
						<select mu-id="currencyId" mu-bind="currencyId;currencies:@options" class="form-control"></select>
					</div>
					<div class="col-md-6" mu-for="error:amount"></div>
					<div class="col-md-6" mu-for="error:currencyId"></div>`
				)

				/* + formGroup('responsibleId', 'Měna',
					`<div mu-widget="UiTomSelect" mu-id="currencyId" mu-bind="currencyId"></div>`
				) */

				+ formGroup('note', 'Poznámka',
					`<input type="text" mu-id="note" mu-bind="note" class="form-control" />`
				)

				+ `</fieldset>
	
				<fieldset><legend>Naše strana</legend>
					<div class="form-group clearfix" mu-id="block_evidenceUid">
						<label mu-for="" class="col-sm-3 control-label">Evidenční číslo</label>
						<div class="col-sm-9" mu-bind="evidenceUid"></div>
					</div>`

				+ formGroup('buSubjectId', 'Subjekt',
					`<div mu-widget="UiTomSelect" mu-id="buSubjectId" mu-bind="buSubjectId"></div>`
				)
				+ `</fieldset>
				
				<fieldset><legend>Druhá strana</legend>`

				+ formGroup('partnerEvidenceUid', 'Orig. Č',
				`<input type="text" mu-id="partnerEvidenceUid" mu-bind="partnerEvidenceUid" class="form-control" />`
				)

				+ formGroup('partnerBuSubjectId', 'Subjekt',
					`<div mu-widget="UiBuSubjectSelector" mu-id="partnerBuSubject" mu-bind="partnerBuSubjectId"></div>`
				)
				+ `</fieldset>
				
				<fieldset><legend>Další údaje</legend>`

				+ formGroup('date', 'Datum',
					`<input type="date" mu-id="date" mu-bind="date" class="form-control" />`
				)

				+ formGroup('dateFrom', 'Datum platnosti od',
					`<input type="date" mu-id="dateFrom" mu-bind="dateFrom" class="form-control" />`
				)

				+ formGroup('dateTo', 'Datum platnosti do',
					`<input type="date" mu-id="dateTo" mu-bind="dateTo" class="form-control" />`
				)

				/* + formGroup('dateProlong', 'Datum prodloužení',
					`<input type="date" mu-id="dateProlong" mu-bind="dateProlong" class="form-control" />`
				)

				+ formGroup('dateProlongChangeTerm', 'Termín změny',
					`<input type="date" mu-id="dateProlongChangeTerm" mu-bind="dateProlongChangeTerm" class="form-control" />`
				) */
				+ `<div class="buttons" mu-id="pButtons"><span mu-id="bSave" class="btn btn-primary">Uložit</span></div>
			</div>`
		);

		this.muRegisterEvent('dmsDocumentTypeChange');
	}

	protected promiseInit: Promise<void>|null = null;
	async afterIndex() {
		super.afterIndex();

		this.muBindData({
			dmsDocumentTypeId: null,
			evidenceUid: 'Bude přiřazeno po vytvoření dokumentu',
		});

		const ddcs = (this.muNamedWidget.dmsDocumentClassId as unknown as UiTomSelect);
		ddcs.init();

		(this.muNamedWidget.securityLevel as unknown as UiRadioList).bindItems(UiDms.instance.securityLevels);


		this.promiseInit = new Promise(async(resolve) => {
			const bss = (this.muNamedWidget.buSubjectId as unknown as UiTomSelect);
			bss.init();
			const myBuSubjects = (await UiDms.instance.cpMyBuSubjects.fetch()).write;
			bss.bindItems(myBuSubjects);

			if (myBuSubjects.length == 1) bss.value = myBuSubjects[0].id;

			(this.muNamedWidget.orgDivisionId as unknown as TreeSelector).bindTree(
				await UiDms.instance.cpOrgDivision.fetch()
			);

			/* const cs = (this.muNamedWidget.currencyId as unknown as UiTomSelect);
			cs.init();
			cs.bindItems(await UiDms.instance.cpCurrencies.fetch()); */

			const currencies = await UiDms.instance.cpCurrencies.fetch();

			const documentTypes = (await UiDms.instance.cpDmsDocumentType.fetch()).filter((dt: DmsDocumentType) => !dt.mustHaveParent);

			this.muBindData({
				documentTypes: documentTypes,
				// documentTypesTree: ,
				currencies: currencies.map((item: any) => <any>{ value: item.id, text: item.code }),
			});
			(this.muNamedWidget.newTypesTree as unknown as UiTree).muBindData(SlashTree.parse(documentTypes, 'name', ' - '), {
				bSelectType_click: async (ev: PointerEvent) => {
					// @ts-ignore
					const id = ev.target.dmsDocumentTypeId;
					if (id) this.selectType(await UiDms.instance.getDmsDocumentType(id));
					else {
						MuWidget.getWidget(ev.target)?.muVisible('toggle', 'items');
					}
				}
			});

			resolve();

			// console.log(FD);
			/* for(const key in fieldDefs)
			{
				const fieldDef = fieldDefs[key];
				if (!fieldDef.edit) continue;
				const fieldType = fieldDef.edit === true ? fieldDef.type : fieldDef.edit;
				const editFieldDef = editFieldDefs[fieldType];
				if (!editFieldDef) throw "No editFieldDefs[" + fieldType + "]";
				const templateName = "field" + editFieldDef.widget;
				const widget = this.muWidgetFromTemplate(templateName, 'editorFields', {
					...editFieldDef,
					...fieldDef,
				}) as BaseField;
				widget.setupField();
			} */
		});

	}

	async stateId_change() {
		const stateId = (this.muNamedWidget.stateId as unknown as UiRadioList).value;
		if (!stateId) return;
		const state = (await UiDms.instance.cpStates.fetch()).find(s => s.id == stateId);
		this.muVisible(state.code == "canceled", 'block_cancelNote');
	}

	selectType(ddt: DmsDocumentType|null) {
		this.muBindData(ddt
			? { dmsDocumentTypeId: ddt.id, stateOpts: ddt.default.stateOpts }
			: { dmsDocumentTypeId: null }
		);
	}

	protected async setupForm(documentType: DmsDocumentType) {
		super.muBindData({ dmsDocumentTypeName: documentType.name });
		const opts = documentType.opts as DmsDocumentTypeOpts;

		// Uprav formulář podle typu
		if (opts.fields) {
			for(const k in opts.fields) {
				const field = opts.fields[k];
				if (field.visible === false)
					this.muVisible(false, "block_" + k);
				if (field.label) {
					this.ui["label_" + k].innerText = field.label;
				}
			}
		}

		// Název okna
		if (!this.id) {
			(this.ui.modalTitle || this.muParent.ui.modalTitle).innerText = "Nový dokument: " + documentType.name;
		}

		// Druhy
		const ddcs = (this.muNamedWidget.dmsDocumentClassId as unknown as UiTomSelect);
		if (documentType.dmsDocumentClassGroupId) {
			ddcs.replaceOptions((await UiDms.instance.cpDmsDocumentClass.fetch())
				.filter((drc: any) => drc.dmsDocumentClassGroupId == documentType.dmsDocumentClassGroupId)
			);
		}

		// Stavy
		const sts = (this.muNamedWidget.stateId as unknown as UiRadioList);
		sts.bindItems((await UiDms.instance.cpStates.fetch())
			.filter((s: any) => s.workflowId == documentType.workflowId)
			.map((s: any) => <RadioListItem>{id:s.id, title:s.name}))

		let firstEnabled: string|null = sts.value;
		const stateOpts = this.stateOpts || documentType.default.stateOpts;
		for(const sid in sts.items) {
			const disabled = !(stateOpts.enabledStateCodes === null || stateOpts.enabledStateCodes.includes(parseInt(sid)));
			sts.replaceItem({ id: sid, disabled: disabled });
			if (!firstEnabled && !disabled) firstEnabled = sid.toString();
		}
		if (firstEnabled) sts.value = firstEnabled;

		this.stateId_change();
	}

	async muBindData(srcData: any): Promise<void> {
		// Počkat na načtení číselníků
		if (this.promiseInit) await this.promiseInit;
		// datumy
		for(const k of [ "date", "dateFrom", "dateTo"/*, "dateProlong", "dateProlongChangeTerm"*/ ]) {
			if (srcData[k]) srcData[k] = srcData[k].substr(0, 10);
		}
		if (srcData.currencyId) srcData.currencyId = srcData.currencyId.id;
		super.muBindData(srcData);
		if (srcData.dmsDocumentTypeId !== undefined) {
			this.dmsDocumentTypeId = srcData.dmsDocumentTypeId;
			this.muVisible(!!srcData.dmsDocumentTypeId, [ "!selectType", "editor" ]);
		}
		if (srcData.stateOpts) {
			this.stateOpts = srcData.stateOpts;
		}
		if (srcData.parentId) {
			this.ui.parentDmsDocument.innerText = getDocumentName(srcData.parentId);
			this.parentDocument = srcData.parentId;
		}
		if (srcData.dmsDocumentTypeId) {
			//const documentTypes = await UiDms.instance.cpDmsDocumentType.fetch();
			// console.log(new SlashTree(documentTypes, 'name').rootNode);
			const documentType = await UiDms.instance.getDmsDocumentType(srcData.dmsDocumentTypeId); // documentTypes.find((dt: any) => dt.id == srcData.dmsDocumentTypeId);
			this.setupForm(documentType);
			this.muDispatchEvent("dmsDocumentTypeChange", documentType);
		}
		this.stateId_change();
	}
	protected dmsDocumentTypeId: number|null = null;

	muFetchData(): any {
		return { 
			...super.muFetchData(), 
			dmsDocumentTypeId: this.dmsDocumentTypeId,
			parentId: this.parentDocument?.id,
		};
	}

	parentDmsDocument_click() {
		UiDms.instance.openDmsDocumentEditor(this.parentDocument.id);
	}

	async loadItem(id: number) {
		this.id = id;
		this.container.classList.add('loading-data');
		const data = await UiDms.instance.cl.getDocument(id);
		if (!data) {
			UiFlashMessage.instance.add('Nemáte oprávnění číst tento dokument');
			this.muRemoveSelf();
			return;
		}
		this.muBindData(data);
		/* this.ui.modalTitle.innerText = data
			? "Upravit " + getDocumentName(data)
			: "Nový dokument"; */
		this.container.classList.remove('loading-data');
	}

	public async bSave_click()
	{
		const data = this.muFetchData();
		const res = await UiDms.instance.cl.saveDocument(this.id, data);
		if (res.status === "ok") {
			UiFlashMessage.instance.add("Dokument uložen");
			this.onSaved(res.entity);
		} else {
			UiFlashMessage.instance.add("Opravte chyby ve formuláři");
		}
		this.errorMarker.markErrors(res.errorList || []);
	}

	bSetProjectResponsible_click() {
		const op = (this.muNamedWidget.orgProjectId as unknown as UiTomSelect).valueOption;
		if (op) this.muNamedWidget.responsibleId.muBindData({
			name: op.acName,
			id: op.accountId,
		});
	}

	bSetProjectOrgDivision_click() {
		const op = (this.muNamedWidget.orgProjectId as unknown as UiTomSelect).valueOption;
		if (op) this.muNamedWidget.orgDivisionId.muBindData(op.orgDivisionId);
	}
}

export class UiDmsDocumentEditorType extends MuWidget {
	// @ts-ignore
	public id: number;
	// @ts-ignore
	private dmsDocumentType: DmsDocumentType;

	bSelectType_click() {
		(UiDms.instance as unknown as UiDmsDocumentEditor).selectType(this.dmsDocumentType);
	}

	muBindData(srcData: any) {
		this.dmsDocumentType = srcData;
		super.muBindData(srcData);
	}
}

/*<div class="form-group clearfix" mu-id="block_">
			<label mu-for="" class="col-sm-3 control-label">Subjekt</label>
			<div class="col-sm-9">
				<input type="text" mu-id="" mu-bind="" class="form-control" />
			</div>
		</div>

	</fieldset>


		<div class="form-group clearfix" mu-id="block_partnerEvidenceUid">
			<label mu-for="partnerEvidenceUid" class="col-sm-3 control-label">Evidenční číslo druhé strany</label>
			<div class="col-sm-9">

			</div>
		</div>

		<div class="form-group clearfix" mu-id="block_">
			<label mu-for="" class="col-sm-3 control-label">Typ obsahu</label>
			<div class="col-sm-9">
				<input type="text" mu-id="" mu-bind="" class="form-control" />
			</div>
		</div>



		<div class="form-group clearfix" mu-id="block_">
			<label mu-for="" class="col-sm-3 control-label"></label>
			<div class="col-sm-9">
				<input type="text" mu-id="" mu-bind="" class="form-control" />
			</div>
		</div>
	</fieldset>`)
/* this.container.innerHTML = `<h2>Úprava dokumentu</h2>
	<div mu-id="editorFields"></div>
	<div class="buttons"><button mu-id="btSave" class="btn btn-primary">Uložit</button></div>`;
for(const widget of new Set(Object.values(editFieldDefs).map(it => it.widget)))
	this.container.innerHTML += `<div mu-template="field${widget}" mu-widget="${widget}"></div>`; */
